module.exports = __webpack_public_path__ + "static/img/reback.3ca54be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/reback.png
// module id = lIJ7
// module chunks = 66